import { useState } from 'react'
import styled from 'styled-components'
import { useEventListener, useWindowSize } from 'usehooks-ts'
import einkommen_dez from '../MainComponent/einkommen_dezile.json'
import { Chart } from 'components/Chart'
import { ChartAnnotation } from 'components/ChartAnnotation'
import { TextBuilder } from 'components/DynamicText/TextBuilder'
import { TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { useMFContext } from 'components/MFHelpers'

export const EinkommensChart = () => {
  const [userPos, setUserPos] = useState<number>(0)
  const { width } = useWindowSize()
  const isMobile = width < 712
  const percentileId = 0
  const { _t } = useMFContext()
  const locales = {
    xAxis: {
      title: [_t('einkommen_chart_title') + '', ''],
      labels: [_t('lower_5') + '', _t('upper_5') + ''],
    },
    yAxis: {
      title: [
        _t('y_axis_title_income') + '',
        _t('y_axis_subline_1_income') + '',
      ],
    },
  }

  useEventListener('percentiles' as any, (e) => {
    let dec: number = -1
    einkommen_dez.forEach((d, i) => {
      if (e.detail.percentiles[percentileId] > d.p) {
        dec = i + 1
      }
    })
    setUserPos(dec)
  })

  const reading = new TextBuilder()

  var ek_val = +einkommen_dez[einkommen_dez.length - 1].bracket_average
  var group_val =
    Math.round(
      +einkommen_dez[Math.max(0, Math.min(19, userPos - 1))].bracket_average /
        100
    ) * 100

  reading.decide_by_indexgroup(
    userPos,
    [
      [
        [1],
        <>
          <b>{_t('income_reading_1')}</b>
          {_t('income_reading_2', { value: formatNumber(ek_val) })}
        </>,
      ],
      [
        [20],
        <>
          <b>{_t('income_reading_3')}</b>
          {_t('income_reading_4', { value: formatNumber(group_val) })}
        </>,
      ],
    ],
    <>
      <b>{_t('income_reading_5', { value: formatNumber(group_val) })}</b>{' '}
      {_t('income_reading_6', {
        value: (20 - Math.max(0, Math.min(19, userPos))) * 5,
        value1: formatNumber(Math.round(ek_val / 100) * 100),
      })}
    </>
  )
  return (
    <TextWidthExtended>
      <VermoegensChartRoot>
        {
          <Chart
            height={isMobile ? 500 : 600}
            userPos={userPos - 1}
            percentileId={percentileId}
            yDomain={width < 712 ? [0, 360000] : [0, 360000]}
            data={einkommen_dez.map((m) => m.bracket_average)}
            yAxisWidth={0}
            yTicks={[100000, 200000, 300000]}
            labels={{
              xAxisTitle: locales.xAxis.title,
              xAxisLabels: locales.xAxis.labels,
              yAxisTitle: locales.yAxis.title,
            }}
            Annotation={<ChartAnnotation text={_t('income_annotation') + ''} />}
            reading={reading.get()}
          />
        }
      </VermoegensChartRoot>
    </TextWidthExtended>
  )
}

const VermoegensChartRoot = styled.div``

function formatNumber(num: number) {
  if (num > 499999) {
    return ('' + Math.round(num / 100000) / 10).replace('.', ',') + ' Mio.'
  }
  if (num > 9999) {
    return Math.round(num / 1000) + '’000'
  }

  return num.toString()
}
